import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-slurry-header-strip',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './slurry-header-strip.component.html'
})
export class SlurryHeaderStripComponent {
  @Input() ufid = '';
  @Input() status = '';
}
